<template>
<svg :class="size?`w-${size} h-${size}`:`w-6 h-6`" class="fill-current inline-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd"/>
</svg>

</template>

<script>
export default {
	name:"IconPlaySolid",
	props:["size"],
}
</script>